import {lazy} from "react";
import useAddPagesToRoutes from "./preloads/useAddPagesToRoutes";
import useGetMenu from "./widgets/useGetMenu";
const CmsPage = lazy(() => import("./views/cmsPages/CmsPage"));


const exports = {
    routes: [
        {
            name: "cmsPage",
            trans: ["Stranice", "Pages"],
            path: ["stranice", "pages"],
            element: <CmsPage />,
            layouts: ["cms.CmsLayout"],
            menus: {cmsLeft: {position: 30}},
            compile: (id, lang) => {
                if(!id) return `/cms/${["stranice", "pages"][lang]}`;
                return `/cms/${["stranice", "pages"][lang]}/${id}`;
            }
        },
        {name: "cmsPage2", path: ["stranice/:id", "pages/:id"], element: <CmsPage />, layouts: ['cms.CmsLayout']},
    ],
    preloads: [useAddPagesToRoutes],
    widgets: {
        useGetMenu: useGetMenu
    }
}
export default exports;
